import { render } from "./QuickReminders.vue?vue&type=template&id=9d026b9c&scoped=true"
import script from "./QuickReminders.vue?vue&type=script&lang=js"
export * from "./QuickReminders.vue?vue&type=script&lang=js"

import "./QuickReminders.vue?vue&type=style&index=0&id=9d026b9c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d026b9c"]])

export default __exports__